import * as Yup from 'yup';

const maintenanceFiltersSchema = Yup.object({
  status_id: Yup.string()
    .nullable()
    .label('Tila'),
  location_id: Yup.number()
    .nullable()
    .label('Paikka'),
  customer_id: Yup.number()
    .nullable()
    .label('Asiakas'),
  search: Yup.mixed()
    .nullable()
    .label('Vapaa haku')
});

export default maintenanceFiltersSchema;
export type MaintenanceFiltersSchema = ReturnType<
  typeof maintenanceFiltersSchema.cast
>;
